{
  "features": {
    "config": {
      "title": "Компаньон ягнёнка",
      "subtitle": "Настройки интеграции с Twitch",
      "sections": {
        "premiumSkins": {
          "title": "Премиальные облики",
          "description": "Благодаря этому расширению ваши зрители смогут появиться в игре. У них будет возможность определить внешний вид последователя, в том числе купить один из премиальных обликов за Bits. Выберите, сколько Bits вы хотите получать за премиальные облики, или сделайте их бесплатными.",
          "noBitsOption": "Бесплатные премиальные облики",
          "bitsFeatureNotAvailable": "На вашем канале нельзя покупать Bits. Зрители смогут выбрать любой облик бесплатно."
        }
      },
      "actions": {
        "save": "Сохранить изменения"
      }
    },
    "followers": {
      "rafflePopup": {
        "title": "Набор последователей в культ {{channelName}}",
        "subtitle": "Вы победили в розыгрыше!",
        "timeRemaining": "Оставшееся время: {{time}}",
        "message": "В нашем поселении вы сможете превратиться в демона, посвятить каждую секунду своей жизни служению культу ягнёнка и даже отдать за него жизнь. От таких предложений не отказываются.",
        "viewerLinkCta": "Для участия {требуется ваш псевдоним}.",
        "actions": {
          "joinRaffle": "Хочу стать последователем",
          "joinRaffleViewerHasAlreadyJoined": "Вы присоединились к розыгрышу",
          "dismissRaffle": "Всё-таки откажусь",
          "dismissRaffleViewerHasAlreadyJoined": "Закрыть"
        },
        "raffleJoinedMessage": "Ваше рвение похвально. Если вас изберут новым последователем, вы получите уведомление. Это окно можно закрыть."
      },
      "followerBuilder": {
        "title": "Создание последователя",
        "steps": {
          "intro": {
            "message": "Вы присоединились к служителям культа. Созданный вами последователь появится в игре. Учтите, что рано или поздно он умрёт — но его смерть не будет напрасной.",
            "actions": {
              "goToNextStep": "Создать последователя"
            }
          },
          "skinSelection": {
            "actions": {
              "goToNextStep": "Продолжить"
            }
          },
          "colorSelection": {
            "actions": {
              "goToPreviousStep": "Вернуться к обликам",
              "goToNextStep": {
                "variationsForSkin": "Продолжить",
                "noVariationsForSkin": "Создать последователя"
              }
            }
          },
          "variationSelection": {
            "actions": {
              "goToPreviousStep": "Вернуться к цветам",
              "goToNextStep": "Создать последователя"
            }
          }
        }
      }
    },
    "helpOrHinder": {
      "help": "помочь",
      "hinder": "навредить",
      "hhVotingFlyout": {
        "title": "Помочь или навредить?",
        "message": "Сделайте выбор",
        "timeRemaining": "Оставшееся время: {{time}}",
        "voteCount": "Голоса: {{amount}}"
      },
      "outcomeVotingFlyout": {
        "title": "Как {{helpOrHinder}} {{channelName}}?",
        "timeRemaining": "Оставшееся время: {{time}}"
      }
    }
  }
}
